const isArray = () => Array.isArray( arr )

import DragEvents from './drag_events.js';
import { 
    getSTP
} from './uf-functions.js';

import './pricing.scss'

const PricingSlider = () => {
    const pricingSliderSection = document.querySelector('#pricing-slider__section')

    if ( !pricingSliderSection ) return
    
    let pricingTable = [
        {
            actions: .6,
            priceMonthly: 72,
            priceAnnually: 780,
            idAnnualy: 872748,
            idMonthly: 872766,
        }, { 
            actions: .7,
            priceMonthly: 144,
            priceAnnually: 1560,
            idAnnualy: 872749,
            idMonthly: 872767,
        }, { 
            actions: .8,
            priceMonthly: 217,
            priceAnnually: 2340,
            idAnnualy: 872750,
            idMonthly: 872768,
        }, { 
            actions: .9,
            priceMonthly: 289,
            priceAnnually: 3120,
            idAnnualy: 872751,
            idMonthly: 872769,
        }, { 
            actions: 1,
            priceMonthly: 361,
            priceAnnually: 3900,
            idAnnualy: 872752,
            idMonthly: 872770,
        }, { 
            actions: 1.2,
            priceMonthly: 410,
            priceAnnually: 4428,
            idAnnualy: 872753,
            idMonthly: 872771,
        }, { 
            actions: 1.4,
            priceMonthly: 459,
            priceAnnually: 4956,
            idAnnualy: 872754,
            idMonthly: 872772,
        }, { 
            actions: 1.6,
            priceMonthly: 508,
            priceAnnually: 5484,
            savingAnnualy: 612,
            savingMonthly: 51,
            idAnnualy: 872755,
            idMonthly: 872773,
        }, { 
            actions: 1.8,
            priceMonthly: 557,
            priceAnnually: 6012,
            idAnnualy: 872756,
            idMonthly: 872774,
        }, { 
            actions: 2,
            priceMonthly: 606,
            priceAnnually: 6540,
            idAnnualy: 872758,
            idMonthly: 872775,
        }, { 
            actions: 2.5,
            priceMonthly: 681,
            priceAnnually: 7356,
            idAnnualy: 872760,
            idMonthly: 872776,
        }, { 
            actions: 3,
            priceMonthly: 757,
            priceAnnually: 8172,
            idAnnualy: 872761,
            idMonthly: 872777,
        }, { 
            actions: 3.5,
            priceMonthly: 833,
            priceAnnually: 9000,
            idAnnualy: 872762,
            idMonthly: 872778,
        }, { 
            actions: 4,
            priceMonthly: 900,
            priceAnnually: 9720,
            idAnnualy: 872763,
            idMonthly: 872779,
        }, { 
            actions: 4.5,
            priceMonthly: 936,
            priceAnnually: 10104,
            idAnnualy: 872764,
            idMonthly: 872780,
        }, { 
            actions: 5,
            priceMonthly: 971,
            priceAnnually: 10488,
            idAnnualy: 872765,
            idMonthly: 872781,
        }
    ]

    if ( typeof pricingTableIds !== 'undefined' ) {
        if ( isArray(pricingTableIds) ) pricingTable = pricingTableIds
    }

    const pricingTableLength = pricingTable.length

    // elements
    const track = pricingSliderSection.querySelector('.pricing-slider__track-wrapper')
    const cliping_handler = track.querySelector('.pricing-slider__dragger')
    const clipped_track = track.querySelector('.pricing-slider__track-clipped')

    const actionsDisplay = pricingSliderSection.querySelectorAll('.pricing__actions-display')
    const priceMonthlyDisplay = pricingSliderSection.querySelectorAll('.pricing__price-monthly-display')
    const priceAnnuallyDisplay = pricingSliderSection.querySelectorAll('.pricing__price-annually-display')
    const savingAnnualyDisplay = pricingSliderSection.querySelectorAll('.pricing__saving-annually-display')
    const savingMonthlyDisplay = pricingSliderSection.querySelectorAll('.pricing__saving-monthly-display')


    // set .pricing__actions left and right fields in .pricing-slider
    const pricingActions = pricingSliderSection.querySelector('.pricing__actions')
    // first
    pricingActions.children[0].innerHTML = new Intl.NumberFormat('en-EN').format( pricingTable[0].actions * 1000000 )
    // last
    pricingActions.children[1].innerHTML = new Intl.NumberFormat('en-EN').format( pricingTable[pricingTableLength - 1].actions * 1000000 )


    // proportions by pricingTable
    const allActions = pricingTable.reduce( (sum, elem, index) => index > 0 ? sum + elem.actions : sum, 0 )
    const actionsProportionally = pricingTable.map( elem => elem.actions / allActions * 100 )
    const pricingsPositions = []

    actionsProportionally.reduce( (sum, elem, index) => {   
        sum = sum + elem

        // get positions from left in %
        pricingsPositions.push( sum )
        
        const div = document.createElement('div')
        // div.innerHTML = pricingTable[index].actions
        div.classList.add(`pricing-slider__track-part--${index + 1}`)
        if ( Number.isInteger(pricingTable[index].actions) || index === 0 ) div.classList.add(`pricing-slider__track-part--milestone`)
        div.style.left = `${sum}%`
        track.appendChild( div )

        const clone = div.cloneNode(true);
        clipped_track.appendChild( clone )
        
        return sum
    }, -actionsProportionally[0])

    const pricingsPositionsLength = pricingsPositions.length

    // defaults
    let activePricingIndex = 0, activeTimePeriod = 1;

    new DragEvents({
        element: cliping_handler,
        click: true,
        dragging: true,
        vectors: [ 'x' ],
        affectParent: true
    }).render( attributes => {
        const { props, parent, state, updateState } = attributes
        const { element } = props
        const { cursorMovePosition, elementSize, parentSize, event } = state

        if ( event === 'touchmove' || event === 'touchend' || event === 'click' ) {
            updateState({ elementPosition: { x: cursorMovePosition['x'] - parent.offset().left - elementSize['x'] / 2 } })

            const leftMargin = -16; // 16
            const rightMargin = parentSize['x'] - elementSize['x'] + 11 // 16 - 5

            const elementPosition = attributes.state.elementPosition['x']
            pricingsPositions.forEach( (position, index) => {
                
                const positionInPx = parentSize['x'] * (position / 100)
                const positionNextInPx = index === pricingTableLength - 1 ? parentSize['x'] : parentSize['x'] * (pricingsPositions[index + 1] / 100)

                if ( positionInPx - 30 < elementPosition && elementPosition < positionNextInPx + 30 ) {
                    activePricingIndex = index
                    updateState({ elementPosition: { x: positionInPx -16 } })
                }
            })

            if ( attributes.state.elementPosition['x'] <= leftMargin ) {
                activePricingIndex = 0
                updateState({ elementPosition: { x: leftMargin } })
            }
            if ( attributes.state.elementPosition['x'] >= rightMargin ) {
                activePricingIndex = pricingsPositionsLength - 1
                updateState({ elementPosition: { x: rightMargin } });
            }
        }

        if ( event === 'touchmove' || event === 'touchend' || event === 'click' || event === 'load' ) {

            // count savings
            const savingAnnualy = parseInt( pricingTable[activePricingIndex].priceMonthly * 12 - pricingTable[activePricingIndex].priceAnnually );
            const savingMonthly = parseInt( savingAnnualy / 12 );

            // change html content
            [...actionsDisplay].map( element => element.innerHTML = new Intl.NumberFormat('en-EN').format( pricingTable[activePricingIndex].actions * 1000000 ) );
            [...priceMonthlyDisplay].map( element => element.innerHTML = new Intl.NumberFormat('en-EN').format( pricingTable[activePricingIndex].priceMonthly ) );
            [...priceAnnuallyDisplay].map( element => element.innerHTML = new Intl.NumberFormat('en-EN').format( pricingTable[activePricingIndex].priceAnnually ) );
            [...savingAnnualyDisplay].map( element => element.innerHTML = new Intl.NumberFormat('en-EN').format( savingAnnualy ) ); 
            [...savingMonthlyDisplay].map( element => element.innerHTML = new Intl.NumberFormat('en-EN').format( savingMonthly ) );
        }

        element.setProperty('transform', `translate3d(${attributes.state.elementPosition['x'] || -16}px, ${attributes.state.elementPosition['y'] || 0}px, ${attributes.state.elementPosition['z'] || 0}px)`)
        clipped_track.setProperty('clip', `rect(-15px, ${attributes.state.elementPosition['x'] + elementSize['x'] / 2 || 0}px, 15px, -15px)`)

        // if ( event === 'load' ) {
        //     element.setProperty('transform', `translate3d(${parentSize['x'] / 2 - elementSize['x'] / 2 || -16}px, ${attributes.state.elementPosition['y'] || 0}px, ${attributes.state.elementPosition['z'] || 0}px)`)
        //     clipped_track.setProperty('clip', `rect(-15px, ${parentSize['x'] / 2 || 0}px, 15px, -15px)`)
        // }
    })


    const form = pricingSliderSection.querySelector('#pricing__account');
    const input = form.getElementsByTagName('input')[0];
    const pricingUrlSection = pricingSliderSection.querySelector('.pricing__url-section')
    
    // show buy more actions section
    pricingSliderSection.style.height = `${1}px`
    
    const showPricingSlider = () => {
        const pricingSliderSectionHeight = pricingSliderSection.children[0].offsetHeight;
        pricingSliderSection.style.height = `${pricingSliderSectionHeight}px`
        pricingSliderSection.classList.add('pricing-slider__section--active')

        setTimeout( () => {
            pricingSliderSection.classList.add('pricing-slider__section--visible')
        }, 300)
    }
    const scrollToPricingSlider = () => setTimeout( () => {
        // including navigation heights on scroll
        let navigationsHeight = window.ppScrollSpacings ? window.ppScrollSpacings.top : 72
        const pricingSliderSectionTop = getSTP() + pricingSliderSection.getBoundingClientRect().top - navigationsHeight - 20;

        window.scrollTo({
            top: pricingSliderSectionTop,
            behavior: 'smooth'
        })
    }, 200 )
    
    window.addEventListener('resize', e => {
        if ( pricingSliderSection.classList.contains('pricing-slider__section--active') ) showPricingSlider()
    }, false)
    if ( window.location.hash === '#buy-more-core-actions' ) {
        showPricingSlider()
        scrollToPricingSlider()
    }
    [...document.querySelectorAll('.pricing__buy-more-actions')].map( element => element.onclick = e => {
        showPricingSlider()
        scrollToPricingSlider()
    })

    // open pricing slider and fill input with account name from url paremeter ?account=accname
    const urlAccount = new URL( document.location ).searchParams.get( 'account' )
    if ( urlAccount ) {
        input.value = urlAccount
        showPricingSlider()
        scrollToPricingSlider()
    }

    // tabs
    const tabsWrapper = pricingSliderSection.querySelector('.pricing__tabs-wrapper');
    const tabsNavigationTab = tabsWrapper.querySelectorAll('.pricing__tabs-navigation__tab');
    const tabsContentTab = tabsWrapper.querySelectorAll('.pricing__tabs-content__tab');

    // click on tab that has activeTimePeriod index
    tabsNavigationTab[activeTimePeriod].click();

    [...tabsNavigationTab].forEach( ( navTab, index ) => {
        navTab.onclick = e => {
            // change activeTimePeriod
            activeTimePeriod = index;

            // remove active class from all tabs
            [...tabsNavigationTab].forEach( ( navTab, i ) => {
                navTab.classList.remove('pricing__tab--active')
                tabsContentTab[i].classList.remove('pricing__tab--active')
            })

            // add active class to clicked tab
            tabsNavigationTab[index].classList.add('pricing__tab--active')
            tabsContentTab[index].classList.add('pricing__tab--active')
        }
    })


    const data = new FormData()
    data.set( 'action', 'piwik_pro_account_exists' )

    const openCheckout = async e => {
        e.preventDefault()

        data.set( 'account', input.value )

        try {
            const response = await fetch( `/wp-admin/admin-ajax.php`, { method: "POST", body: data } )

            if ( pricingTable[activePricingIndex] ) {

                // TEST with 400 status
                pricingUrlSection.classList.add('pricing__url-section--error')
                pricingUrlSection.classList.add('pricing__url-section--error--bounce')
                setTimeout( () => pricingUrlSection.classList.remove('pricing__url-section--error--bounce'), 500)
                // END TEST with 400 status

                switch ( response.status ) {
                    case 200:
                        pricingUrlSection.classList.remove('pricing__url-section--error')
    
                        Paddle.Checkout.open({
                            customData: { account: input.value },
                            product: activeTimePeriod == 0 ? pricingTable[activePricingIndex].idAnnualy : pricingTable[activePricingIndex].idMonthly,
                        });
                        break;
                        
                    case 404:
                        pricingUrlSection.classList.add('pricing__url-section--error')
    
                        // error bounce
                        pricingUrlSection.classList.add('pricing__url-section--error--bounce')
                        setTimeout( () => pricingUrlSection.classList.remove('pricing__url-section--error--bounce'), 500)
                        break;
                }
            }
        } catch {
            console.error(`account name '${input.value}' does not exist`);
        }
    }
    form.addEventListener('submit', openCheckout, false);



    // NEW TABLE COLLAPSE
    const tableContainer = document.querySelectorAll('.table-container');
    [...tableContainer].map( container => {
        const tableShowMoreButton = container.querySelector('.pricing__table__show-more')
        if ( !tableShowMoreButton ) return;

        const tableBodies = container.querySelectorAll('tbody')
        
        const hideRows = () => {
            let tableRowGroups = 0;
            
            [...tableBodies].map( tableBody => {
                const tableBodyRows = tableBody.children;
                
                // hide all rows except first 2 groups
                [...tableBodyRows].map( (row, index) => {
                    if ( tableRowGroups > 2 ) { 
                        tableBody.classList.add('pricing__table__rows--hidden')
                        tableShowMoreButton.classList.add('pricing__table__show-more--active')
                    }

                    if ( row.querySelector('th') ) tableRowGroups++
                })
            })
        }

        // hide on load
        hideRows();

        tableShowMoreButton.onclick = e => {
            tableShowMoreButton.classList.toggle('pricing__table__show-more--more')

            if ( tableShowMoreButton.classList.contains('pricing__table__show-more--more') ) {
                hideRows();
            } else {
                [...tableBodies].map( tableBody => tableBody.classList.remove('pricing__table__rows--hidden') )
            }
        }
    })
}

PricingSlider()